import {moment} from "@/src/modules/core/lib";

export type BuildDaysParams = {
  dates_range: {from: Date; to: Date};
  excluded_dates: string[];
};

/**
 * Builds the `days` array for the safelisting API: each calendar day in the range
 * (minus excluded), as plain `YYYY-MM-DD` strings.
 */
export function buildDaysFromRange(params: BuildDaysParams): string[] {
  const {dates_range, excluded_dates} = params;
  const set = new Set(excluded_dates);
  const out: string[] = [];
  const start = moment(dates_range.from).startOf("day");
  const end = moment(dates_range.to).startOf("day");
  let cursor = start.clone();
  while (cursor.isSameOrBefore(end)) {
    const dateStr = cursor.format("YYYY-MM-DD");
    if (!set.has(dateStr)) {
      out.push(dateStr);
    }
    cursor = cursor.add(1, "day");
  }
  return out;
}
